import type { APISuperAdminTenantResponseType } from "@/core/data_sources/models/APISuperAdminTenant";
import type { BasicQuery } from "@/core/data_sources/services";
import { get } from "@/core/utils/request";

export type SuperAdminTenantsQuery = BasicQuery &
  Partial<{
    search: string;
  }>;

export function getSuperAdminTenants<Q extends SuperAdminTenantsQuery>(
  query: Q,
) {
  return get<APISuperAdminTenantResponseType[]>("/super-admin/tenants/", {
    params: query,
  });
}
